// "ziggy" is an alias defined in webpack.mix.js. Eslint can't resolve this alias however.
// eslint-disable-next-line import/no-unresolved
import { ZiggyVue } from "ziggy";
import Vue from "vue";
import VueRouter from "vue-router";
import VueRouterBackButton from "vue-router-back-button";
import globalHelperMethods from "./util/helpers";
import store from "./store";
import NavigatorPlugin from "./mixins/navigator/navigator_plugin";
import router from "./router/router";

// Plugins
// import './plugins/sentry'
import "./plugins/axios";
// To be used when designing a full page, however this collides with current test implementation
// See i.e. PartnerBankAccountTest:L54
// import router from "./plugins/router";
import "./plugins/ant-design";
import "./plugins/pusher";
import "./plugins/moment";
import "./plugins/currency-input";
import "./plugins/lodash";
import "./plugins/material-design-icons";
import "./plugins/froala";
import "./plugins/string-helpers";
import "./plugins/vue-select";
import "./plugins/vue-mq";
import "./plugins/v-lazy-component";
import Pages from "./pages/pages";
import { arbitraryAnchorClickHandler } from "./router/click_handler";

// import PhoneDropdownComponent from "./components/navbar/PhoneDropdownComponent.vue";
import NewDesignComponents from "./new_design_components/new_design_components";

window.Vue = Vue;

Vue.config.productionTip = false;

// Navbar Component
Vue.component("MainNavbarComponent", require("./components/navbar/MainNavbarComponent.vue").default);
Vue.component("SearchBarWrapperComponent", require("./components/navbar/SearchBarWrapperComponent.vue").default);
Vue.component("SearchBarComponent", require("./components/navbar/SearchBarComponent.vue").default);
Vue.component("PhoneDropdownComponent", require("./components/navbar/PhoneDropdownComponent.vue").default);

// Components
Vue.component("ActionGroupListComponent", require("./components/ActionGroupListComponent").default);
Vue.component("Amount", require("./components/AmountComponent.vue").default);
Vue.component("DashboardCard", require("./components/DashboardCard.vue").default);
Vue.component("DatePickerComponent", require("./components/DatePickerComponent.vue").default);
Vue.component("TimePickerComponent", require("./components/TimePickerComponent.vue").default);
Vue.component("DatePickerWithSuggestions", require("./components/DatePickerWithSuggestions.vue").default);
Vue.component("FormComponent", require("./components/FormComponent.vue").default);
Vue.component("LicensePlate", require("./components/LicensePlateComponent.vue").default);
Vue.component("OrderBy", require("./components/OrderByComponent.vue").default);
Vue.component("AmountInput", require("./components/input/AmountComponent.vue").default);
Vue.component("EnergyInput", require("./components/input/EnergyComponent.vue").default);
Vue.component("PercentageInput", require("./components/input/PercentageComponent.vue").default);
Vue.component("SurfaceInput", require("./components/input/SurfaceComponent.vue").default);
Vue.component("VolumeInput", require("./components/input/VolumeComponent.vue").default);
Vue.component("YearInput", require("./components/input/YearComponent.vue").default);
Vue.component("LaravelPagination", require("./components/pagination/LaravelPagination.vue").default);
Vue.component("TaskTargetComponent", require("./components/settings/TaskTargetComponent").default);

// Modules
// Activity
Vue.component("CustomerActivityTimeline", require("./modules/activity/components/ActivityTimelineComponent.vue").default);
// Address
Vue.component("AddressInputSearch", require("./modules/address/components/InputSearchComponent.vue").default);
// Agency
Vue.component("AgencyContactDetailsComponent", require("./modules/agency/components/AgencyContactDetailsComponent.vue").default);
// Analysis
Vue.component("CustomerAnalysisPage", require("~/pages/analysis/CustomerAnalysisPage").default);
Vue.component("MailifyConfigurationPage", require("./modules/mailify/components/ConfigurationPageComponent").default);
// Aplaza
Vue.component("AplazaExport", require("./modules/aplaza/components/ExportComponent").default);
Vue.component("AplazaUserCreate", require("./modules/aplaza/components/UserCreateComponent").default);
Vue.component("AplazaValidateUserCredentialsBadge", require("./modules/aplaza/components/ValidateUserCredentialsBadgeComponent").default);
// Attachable
Vue.component("AttachableCopyModal", require("./modules/attachable/components/CopyModalComponent.vue").default);
Vue.component("AttachableMoveModal", require("./modules/attachable/components/MoveModalComponent.vue").default);
Vue.component("Breadcrumbs", require("./modules/attachable/components/Breadcrumbs.vue").default);
Vue.component("AttachableWidgetComponent", require("./modules/attachable/components/WidgetComponent.vue").default);
// Attachable category
Vue.component("AttachableCategoryAttachableUploadModal", require("./modules/attachable_category/components/AttachableUploadModalComponent.vue").default);
Vue.component("AttachableCategoryPaginatedOverview", require("./modules/attachable_category/components/PaginatedOverviewComponent.vue").default);
Vue.component("AttachableCategoryTemplatePlaceholder", require("./modules/attachable_category/components/TemplatePlaceholderComponent.vue").default);
// Auth
Vue.component("AuthLogin", require("./modules/auth/components/LoginComponent.vue").default);
// AX messages
Vue.component("AxCreateFutureAddressComponent", require("./modules/ax_message/components/CreateFutureAddressComponent.vue").default);
// BNP bank guarantee
Vue.component("RequestBNPBankGuarantee", require("./modules/bnp_bank_guarantee/components/RequestBNPBankGuaranteeComponent.vue").default);
// Calendar
Vue.component("CalendarEventCreateOrEditComponent", require("./modules/calendar_event/components/CreateOrEditBladeWrapperComponent.vue").default);
Vue.component("CalendarEventCreateActionButtonComponent", require("./modules/calendar_event/components/ActionButtonComponent.vue").default);
Vue.component("CalendarEventCreateOrEditModalComponent", require("./modules/calendar_event/components/ModalCreateOrEditComponent.vue").default);
Vue.component("CalendarEventTableComponent", require("./modules/calendar_event/components/TableComponent").default);
// Category
Vue.component("CategoryCollapsableAttachableOverview", require("./modules/category/components/CollapsableAttachableOverviewComponent.vue").default);
Vue.component("CategoryPaginatedAttachableOverview", require("./modules/category/components/PaginatedAttachableOverviewComponent.vue").default);
Vue.component("CategorySelect", require("./modules/category/components/SelectCategoryComponent").default);
Vue.component("CustomerAvatar", require("./modules/customer/components/AvatarComponent.vue").default);
// Customer
Vue.component("CustomerAttachableUpload", require("./modules/customer/components/AttachableUploadComponent.vue").default);
Vue.component("CustomerCreateCustomerProperty", require("./modules/customer/components/CreateCustomerPropertyComponent.vue").default);
Vue.component("CustomerEditCustomerProperties", require("./modules/customer/components/EditCustomerPropertyComponent.vue").default);
Vue.component("CustomerSearchByName", require("./modules/customer/components/SearchByNameComponent.vue").default);
Vue.component("CustomerSearchByNameInput", require("./modules/customer/components/SearchByNameInputComponent.vue").default);
Vue.component("EditCustomerPropertyOverviewComponent", require("./modules/customer/components/EditCustomerPropertyOverviewComponent").default);
Vue.component("CustomerUsernameEditComponent", require("./modules/customer/components/UsernameEditComponent.vue").default);
Vue.component("CustomerPageResponsiveLayout", require("./modules/customer_page_responsive_layout/ResponsiveLayout.vue").default);
// Current living condition
Vue.component("CustomerCurrentLivingConditionEditPageComponent", require("./modules/customer_current_living_condition/components/EditPageComponent").default);
Vue.component("CustomerCurrentLivingConditionNewEditPageComponent", require("./modules/customer_current_living_condition/components/NewEditPageComponent").default);
Vue.component("CustomerCurrentLivingConditionShowPageComponent", require("./modules/customer_current_living_condition/components/ShowPageComponent").default);
// Customer property
Vue.component("AddressIndexComponent", require("./modules/customer_property/components/IndexPageComponent").default);
Vue.component("CustomerPropertyEditComponent", require("./modules/customer_property/components/EditComponent.vue").default);
Vue.component("CustomerPropertyEditPageComponent", require("./modules/customer_property/components/EditPageComponent.vue").default);
Vue.component("CustomerPropertyShowPageComponent", require("./modules/customer_property/components/ShowPageComponent.vue").default);
Vue.component("CustomerSelect", require("./modules/customer/components/SearchByNameInputComponent").default);
// Department
Vue.component("UserDepartmentsSelect", require("./modules/user_department/components/SelectUserDepartmentComponent").default);
Vue.component("UserDepartmentBadgeComponent", require("./modules/user_department/components/BadgeComponent.vue").default);
// Document
Vue.component("DocumentUpload", require("./modules/document/components/DocumentUploadComponent.vue").default);
// Document type
Vue.component("DocumentTypeListItemComponent", require("./modules/document_type/components/ListItemComponent").default);
Vue.component("DocumentTypeSelectableListComponent", require("./modules/document_type/components/SelectableListComponent").default);
// Email
Vue.component("EmailCustomerPaginatedOverviewComponent", require("./modules/email/components/CustomerPaginatedOverviewComponent").default);
Vue.component("EmailPaginatedOverviewComponent", require("./modules/email/components/PaginatedOverviewComponent").default);
Vue.component("EmailStatus", require("./modules/email/components/EmailStatusComponent.vue").default);
Vue.component("PaginatedOutgoingEmailComponent", require("./modules/email/components/PaginatedOutgoingComponent").default);
// Email account
Vue.component("PaginatedProcessedEmailComponent", require("./modules/email_account/components/PaginatedProcessedEmailComponent.vue").default);
Vue.component("PaginatedUnprocessedEmailComponent", require("./modules/email_account/components/PaginatedUnprocessedEmailComponent.vue").default);
Vue.component("EmailAccountsSelect", require("./modules/email_account/components/SelectEmailAccountsComponent.vue").default);
// Email template
Vue.component("EmailTemplatesSelect", require("./modules/email_template/components/SelectEmailTemplatesComponent.vue").default);
// External person
Vue.component("EditExternalPersonPropertyComponent", require("./modules/external_person_property/components/EditComponent").default);
// HTML email
Vue.component("SelectHtmlEmailTemplateComponent", require("./modules/html_email_template/components/SelectHtmlEmailTemplateComponent.vue").default);
Vue.component("HtmlEmailTemplatePaginatedOverviewComponent", require("./modules/html_email_template/components/PaginatedOverviewComponent.vue").default);
Vue.component("CreateOrEditHtmlEmailTemplateComponent", require("./modules/html_email_template/components/CreateOrEditComponent.vue").default);
// Invitation Portal
Vue.component("InvitationPortalInvitationSources", require("./modules/invitation_portal/InvitationSources.vue").default);
// MINT
Vue.component("MintInterestratePage", require("./modules/mint/interestrates/components/InterestRatePageComponent.vue").default);
// Mortgage
Vue.component("MortgageDocumentTypeOverviewEdit", require("./modules/mortgage/components/DocumentTypeOverviewEditComponent.vue").default);
Vue.component("MortgageDocumentTypeOverviewShow", require("./modules/mortgage/components/DocumentTypeOverviewShowComponent.vue").default);
Vue.component("MortgageEditMortgageProperties", require("./modules/mortgage/components/EditMortgagePropertiesComponent.vue").default);
Vue.component("MortgageShowMortgageProperties", require("./modules/mortgage/components/ShowMortgagePropertiesComponent.vue").default);
Vue.component("MortgageProgressSummary", require("./modules/mortgage/components/MortgageProgressSummaryComponent.vue").default);
Vue.component("MortgageProgressGraph", require("./modules/mortgage/components/MortgageProgressGraphComponent.vue").default);
Vue.component("CreateOrEditMortgageComponent", require("./modules/mortgage/components/CreateOrEditComponent.vue").default);
// Mortgage progress
Vue.component("MortgageProgressEditComponent", require("./modules/mortgage_progress/components/EditComponent.vue").default);
Vue.component("MortgageProgressShowComponent", require("./modules/mortgage_progress/components/ShowComponent.vue").default);
// Mortgage progress group
Vue.component("MortgageProgressGroupSelectComponent", require("./modules/mortgage_progress_group/components/SelectComponent.vue").default);
// Note
Vue.component("NoteCategoryPaginatedOverviewComponent", require("./modules/note/components/PaginatedCategoryComponent.vue").default);
Vue.component("NoteCategoryOverviewComponent", require("./modules/note/components/CategoryOverviewComponent.vue").default);
Vue.component("NoteCountComponent", require("./modules/note/components/CountComponent.vue").default);
Vue.component("NotesByCategoryDrawerOverviewComponent", require("./modules/note/components/ByCategoryDrawerOverviewComponent.vue").default);
// Policy
Vue.component("PolicySiviMessages", require("./modules/policy/components/PolicySiviMessagesComponent.vue").default);
Vue.component("PolicyDescriptionComponent", require("./modules/policy/components/PolicyDescriptionComponent.vue").default);
// Policy group
Vue.component("PolicyGroupPropertyComponent", require("./modules/policy_group/components/PropertyComponent").default);
// Product label
Vue.component("ShowProductLabel", require("./modules/product_label/components/ShowProductLabelComponent").default);
Vue.component("GlobalProductLabelsSelect", require("./modules/product_label/components/GlobalSelectProductLabelComponent.vue").default);
Vue.component("ProductLabelsSelect", require("./modules/product_label/components/SelectProductLabelComponent").default);
// Property
Vue.component("PropertyEditComponent", require("./modules/property/components/EditComponent.vue").default);
Vue.component("PropertyInputComponent", require("./modules/property/components/PropertyInputComponent.vue").default);
Vue.component("PropertySearchByAddress", require("./modules/property/components/SearchByAddressComponent.vue").default);
Vue.component("PropertyShowComponent", require("./modules/property/components/ShowComponent.vue").default);
// Reporting
Vue.component("ReportingMortgagesOverviewComponent", require("./modules/reporting/components/ReportingMortgagesOverviewComponent.vue").default);
Vue.component("ReportingOverviewComponent", require("./modules/reporting/components/ReportingOverviewComponent.vue").default);
Vue.component("ReportingPoliciesOverviewComponent", require("./modules/reporting/components/ReportingPoliciesOverviewComponent.vue").default);
Vue.component("ReportingTasksOverviewComponent", require("./modules/reporting/components/ReportingTasksOverviewComponent.vue").default);
// Rotate To Landscape Message
Vue.component("RotateToLandscapeComponent", require("./modules/rotate_to_landscape/RotateToLandscapeMessageComponent.vue").default);
// Settings
Vue.component("OfficeForm", require("./modules/settings/organization/office/components/OfficeComponent.vue").default);
Vue.component("OfficeRegionsPage", require("./modules/settings/organization/office/pages/OfficeRegionsPage").default);
Vue.component("RegionForm", require("./modules/settings/organization/region/components/RegionComponent").default);
Vue.component("ExternalPersonContactDetailsComponent", require("./modules/settings/entity/external_person/components/ContactDetailsComponent").default);
// Signal
Vue.component("CustomerSignalOverview", require("./modules/signals/components/CustomerOverviewComponent").default);
Vue.component(
  "SharedSignalQueryOverviewComponent",
  require("./modules/signals/components/SharedSignalQueryOverviewComponent").default,
);
Vue.component("UserQueryOverviewComponent", require("./modules/signals/components/UserQueryOverviewComponent.vue").default);
// SIVI
Vue.component("AfdProcessingOverview", require("./modules/sivi/components/ProcessingOverviewComponent.vue").default);
Vue.component("AfdMessageDescription", require("./modules/sivi/components/AFDMessageByIdDescriptionComponent.vue").default);
Vue.component("PackageMessagesOverview", require("./modules/sivi/components/PaginatedPackageMessagesOverviewComponent.vue").default);
Vue.component("PolicyMessagesOverview", require("./modules/sivi/components/PaginatedPolicyMessagesOverviewComponent.vue").default);
Vue.component("ProcessAfdPackageMessage", require("./modules/sivi/components/ProcessAFDPackageMessageComponent.vue").default);
Vue.component("SaveSiviMessageAttachmentsComponent", require("./modules/sivi/components/LinkSiviMessageAttachmentsOverviewComponent").default);
Vue.component("SiviAttribute", require("./modules/sivi/components/SiviAttributeComponent.vue").default);
Vue.component("SiviEntity", require("./modules/sivi/components/SiviEntityComponent.vue").default);
Vue.component("SiviMessage", require("./modules/sivi/components/SiviMessageComponent.vue").default);
// Static search
Vue.component("FavoriteStaticSearches", require("./modules/static_search/components/FavoriteStaticSearches.vue").default);
Vue.component("SearchCsvExportComponent", require("./modules/static_search/components/SearchCSVExportComponent.vue").default);
Vue.component("SelectionOverviewComponent", require("./modules/static_search/selection/OverviewComponent").default);
Vue.component("StaticSearchCsvExportComponent", require("./modules/static_search/components/StaticSearchCSVExportComponent.vue").default);
Vue.component("StaticSearches", require("./modules/static_search/components/StaticSearches.vue").default);
Vue.component("CacheStaticSearchesButtonComponent", require("./modules/static_search/components/CacheStaticSearchesButtonComponent").default);
// Task
Vue.component("CallbackOverview", require("./modules/task/components/CallbackOverviewComponent.vue").default);
Vue.component("CreateOrEditTaskComponent", require("./modules/task/components/CreateOrEditTaskComponent").default);
Vue.component("CustomerTaskOverview", require("./modules/task/components/CustomerTaskOverviewComponent.vue").default);
Vue.component("CustomersTaskDrawerComponent", require("./modules/task/components/CustomersTaskDrawerComponent.vue").default);
Vue.component("CustomersTaskOverview", require("./modules/task/components/CustomersTaskOverviewComponent.vue").default);
Vue.component("TaskOverview", require("./modules/task/components/TaskOverviewComponent.vue").default);
// TaskList
Vue.component("CreateTaskListComponent", require("./modules/task_list/components/CreateTaskListTemplateComponent.vue").default);

// Taskable
Vue.component("TaskableBadgeComponent", require("./modules/task/components/TaskableBadgeComponent").default);
// Templating
Vue.component("TemplateEditComponent", require("./modules/templating/components/TemplateEditComponent.vue").default);
Vue.component("TemplatingSelectComponent", require("./modules/templating/components/SelectionComponent.vue").default);
// User
Vue.component("UserBadgeGroup", require("./modules/user/components/BadgeGroupComponent.vue").default);
Vue.component("UserBadge", require("./modules/user/components/BadgeComponent.vue").default);
Vue.component("UsersSelect", require("./modules/user/components/SelectUsersComponent.vue").default);
Vue.component("UsersByExtension", require("./modules/user/components/UsersByExtensionComponent.vue").default);
Vue.component("ToggleUserActiveComponent", require("./modules/user/components/ToggleUserActiveComponent.vue").default);
// Compare
Vue.component("MortgageRefinance", require("./modules/compare/MortgageRefinance.vue").default);
Vue.component("DeathInsurance", require("./modules/compare/DeathInsurance.vue").default);
Vue.component("CarInsurance", require("./modules/compare/CarInsurance.vue").default);
Vue.component("GroupActionForAllCustomersComponent", require("./modules/group_action/GroupActionForAllCustomersComponent.vue").default);
Vue.component("GroupActionsForSearchComponent", require("./modules/group_action/GroupActionsForSearchComponent.vue").default);
Vue.component("GroupActionStatusComponent", require("./modules/group_action/GroupActionStatusComponent").default);
Vue.component("ComparisonSummary", require("./modules/compare/ComparisonSummary").default);
// Layout
Vue.component("LetterLayoutCreateEditOrShowComponent", require("./modules/letter_layout/components/CreateEditOrShowComponent.vue").default);
// HDN Message
Vue.component("HdnIndex", require("./modules/hdn/Index").default);
// Vue.use(Router);

// Plugins
Vue.use(NewDesignComponents);
Vue.use(Pages);
Vue.use(ZiggyVue);
Vue.use(VueRouter);
Vue.use(NavigatorPlugin);
Vue.use(VueRouterBackButton, { router, ignoreRoutesWithSameName: true });

const main = new Vue({
  el: "#page-wrapper",
  router,
  store,
  methods: {
    onClick: (event) => arbitraryAnchorClickHandler(event),
    ...globalHelperMethods,
  },
});

window.store = store;
window.main = main;
